import { mxgraphInstance } from './mxgraphFactory';

/**
 * Shape
 */
export const mxActor = mxgraphInstance.mxActor;
export const mxArrow = mxgraphInstance.mxArrow;
export const mxArrowConnector = mxgraphInstance.mxArrowConnector;
export const mxCloud = mxgraphInstance.mxCloud;
export const mxConnector = mxgraphInstance.mxConnector;
export const mxCylinder = mxgraphInstance.mxCylinder;
export const mxDoubleEllipse = mxgraphInstance.mxDoubleEllipse;
export const mxEllipse = mxgraphInstance.mxEllipse;
export const mxHexagon = mxgraphInstance.mxHexagon;
export const mxImageShape = mxgraphInstance.mxImageShape;
export const mxLabel = mxgraphInstance.mxLabel;
export const mxLine = mxgraphInstance.mxLine;
export const mxMarker = mxgraphInstance.mxMarker;
export const mxPolyline = mxgraphInstance.mxPolyline;
export const mxRectangleShape = mxgraphInstance.mxRectangleShape;
export const mxRhombus = mxgraphInstance.mxRhombus;
export const mxShape = mxgraphInstance.mxShape;
export const mxStencil = mxgraphInstance.mxStencil;
export const mxStencilRegistry = mxgraphInstance.mxStencilRegistry;
export const mxSwimlane = mxgraphInstance.mxSwimlane;
export const mxText = mxgraphInstance.mxText;
export const mxTriangle = mxgraphInstance.mxTriangle;